import type { TOC } from '@ember/component/template-only'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { LinkTo } from '@ember/routing'

interface Signature {
  Element: HTMLAnchorElement
  Args: {
    route?: string
  }
  Blocks: {
    default: []
  }
}
export const PageHeaderReturnLink: TOC<Signature> = <template>
  {{#if @route}}
    <LinkTo @route={{@route}} class="text-black" data-test-return-link ...attributes>
      <PhosphorIcon @icon="phosphor-caret-left-bold" class="h-3 w-3" />
      <span class="underline">{{yield}}</span>
    </LinkTo>
  {{/if}}
</template>

export default PageHeaderReturnLink
